export default "__VITE_ASSET__9f8GnXjD__"